export const NEW_USER = "new_user";
export const NEW_USER_UNCONFIRMED = "new_user_unconfirmed"; // did not check the "I understand" yet
export const RETURNING_USER = "returning_user";
export const USER_UNSURE = "user_unsure";
